import PdMedia from '@/components/pd-media/pd-media'
import clsx from 'clsx'
import { FC } from 'react'
import TitleAndDesc from '@/components/standard/title-and-desc'
import SlidingTabs from '@/components/standard/pd-sliding-tabs'
import { SemanticTextTag } from '@/common/pd-meta-components-types'
import SemanticText from '@/components/standard/semantic-text'

type Section11Type = {
  title: string
  mediaGroup: Array<{
    tabTitle: string
    mediaUrl: string
    tagGroup: Array<{
      title: string
      desc: string
    }>
  }>
  theme?: string
  itemTitleTag?: SemanticTextTag
}
const Section11: FC<Section11Type> = ({ theme, title, mediaGroup, itemTitleTag }) => {
  return (
    <div className={clsx('w-full h-fit', 'py-15 laptop:py-30', `pd-theme-${theme}`, 'bg-anti-blk')}>
      <div className={clsx('w-full max-w-300 mx-auto')}>
        <TitleAndDesc title={title} titleTag="h2" />
        <SlidingTabs
          contentBoxClassName={clsx('w-full h-553px laptop:[aspect-ratio:2/1]')}
          tabsBoxClassName={clsx('pb-3 laptop:pb-6 flex justify-center')}
          tabsContainerClassName="laptop:rounded-full"
          containerClassName={clsx('w-full px-6 laptop:px-0')}
          tabLabels={mediaGroup.map((item) => item.tabTitle || '')}
          bgColor="bg-container-third"
          tabEleClassName="text-fc-secondary rounded-full hover:bg-white/20 active:bg-black/20"
        >
          {mediaGroup.map((item) => {
            return (
              <div
                className={clsx(
                  'w-full flex flex-col justify-between',
                  'laptop:flex-row laptop:[aspect-ratio:2/1]',
                  'bg-container-secondary'
                )}
                key={item.tabTitle}
              >
                <div
                  className={clsx(
                    'h-226px laptop:w-1/2 laptop:h-full',
                    'p-6 laptop:p-12 overflow-y-scroll scroll-hidden'
                  )}
                >
                  <div className={clsx('h-full flex flex-col justify-center')}>
                    {item.tagGroup.map((tag) => (
                      <>
                        <SemanticText
                          as={itemTitleTag}
                          defaultTag="h2"
                          className={clsx(
                            'text-16 laptop:text-20 font-semibold',
                            'mb-2 laptop:mb-4',
                            'text-fc-primary'
                          )}
                        >
                          {tag.title}
                        </SemanticText>
                        <p className={clsx('text-14', 'mb-3 laptop:mb-6', 'text-fc-secondary')}>{tag.desc}</p>
                      </>
                    ))}
                  </div>
                </div>
                <div className={clsx('w-full [aspect-ratio:1/1] laptop:w-1/2 h-full')}>
                  <PdMedia src={item.mediaUrl || ''} mask={false} />
                </div>
              </div>
            )
          })}
        </SlidingTabs>
      </div>
    </div>
  )
}

export default Section11
